export const LOYALTY_HYATT_CHIP_LABELS = {
  title: "World of Hyatt loyalty required",
  description:
    "A World of Hyatt membership number matching the traveler name will be required to complete this booking. Not a member?",
  enroll_url: "https://www.hyatt.com/en-US/member/enroll",
  enroll_label: "Join now for free.",
};
